import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { VisitorRegistrationPreparationComponent } from './visitor-registration-preparation.component';



@NgModule({
  declarations: [
    VisitorRegistrationPreparationComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class VisitorRegistrationPreparationModule { }
